import React from 'react';
import PropTypes from 'prop-types';

import { IconButton, CodeSquare01Icon, Tooltip } from '@metarouter-private/mr-mui';
import { useQuerySampleEvents } from '@ion/api';

export default function ManageSampleEventsButton({ onClick }) {
  const { data: sampleEvents, loading } = useQuerySampleEvents();

  const isDisabled = loading || sampleEvents.length === 0;
  const tooltipTitle = buildTooltipTitle({ loading, sampleEvents });

  return (
    <Tooltip title={tooltipTitle}>
      <span>
        <IconButton onClick={onClick} disabled={isDisabled} data-test-id="manage-sample-events-button">
          <CodeSquare01Icon />
        </IconButton>
      </span>
    </Tooltip>
  );
}

ManageSampleEventsButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

function buildTooltipTitle({ loading, sampleEvents }) {
  if (loading) return 'Loading...';
  if (sampleEvents.length === 0) return 'No saved sample events to manage';
  return 'Manage sample events';
}
